
<template>
  <div class="titlebox">
    <div class="left" >
      <div  class="left"  v-if="leftShow">
          <svg :width="`25px`" :height="`8px`">
              <defs>
                  <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="linearGradient-3-1">
                      <stop stop-color="#1655B0" offset="0%"></stop>
                      <stop stop-color="#1655AF" stop-opacity="0" offset="100%"></stop>
                  </linearGradient>
              </defs>
              <g id="切图" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="画板" transform="translate(-30.000000, -179.000000)" fill="url(#linearGradient-3-1)">
                      <path d="M55.4257812,179.015625 L55.4257812,187.015625 L50.4257812,187.015625 L50.4257812,179.015625 L55.4257812,179.015625 Z M45.4257812,179.015625 L45.4257812,187.015625 L40.4257812,187.015625 L40.4257812,179.015625 L45.4257812,179.015625 Z M35.4257812,179.015625 L35.4257812,187.015625 L30.4257812,187.015625 L30.4257812,179.015625 L35.4257812,179.015625 Z" id="形状结合" transform="translate(42.925781, 183.015625) scale(-1, 1) translate(-42.925781, -183.015625) "/>
                  </g>
              </g>
          </svg>
          <div class="txt">
              {{txt}}
          </div>
      </div>
    </div>
     <div class="right" >
       <div  class="right"  v-if="rightShow">
            <svg :width="`115px`" :height="`8px`">
              <defs>
                  <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="linearGradient-3-2">
                      <stop stop-color="#1655B0" offset="0%"></stop>
                      <stop stop-color="#1655AF" stop-opacity="0" offset="100%"></stop>
                  </linearGradient>
              </defs>
              <g id="切图" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="画板" transform="translate(-188.000000, -181.000000)" fill="url(#linearGradient-3-2)">
                      <path d="M303.425781,181.015625 L303.425781,189.015625 L298.425781,189.015625 L298.425781,181.015625 L303.425781,181.015625 Z M293.425781,181.015625 L293.425781,189.015625 L288.425781,189.015625 L288.425781,181.015625 L293.425781,181.015625 Z M283.425781,181.015625 L283.425781,189.015625 L278.425781,189.015625 L278.425781,181.015625 L283.425781,181.015625 Z M273.425781,181.015625 L273.425781,189.015625 L268.425781,189.015625 L268.425781,181.015625 L273.425781,181.015625 Z M263.425781,181.015625 L263.425781,189.015625 L258.425781,189.015625 L258.425781,181.015625 L263.425781,181.015625 Z M253.425781,181.015625 L253.425781,189.015625 L248.425781,189.015625 L248.425781,181.015625 L253.425781,181.015625 Z M243.425781,181.015625 L243.425781,189.015625 L238.425781,189.015625 L238.425781,181.015625 L243.425781,181.015625 Z M233.425781,181.015625 L233.425781,189.015625 L228.425781,189.015625 L228.425781,181.015625 L233.425781,181.015625 Z M223.425781,181.015625 L223.425781,189.015625 L218.425781,189.015625 L218.425781,181.015625 L223.425781,181.015625 Z M213.425781,181.015625 L213.425781,189.015625 L208.425781,189.015625 L208.425781,181.015625 L213.425781,181.015625 Z M203.425781,181.015625 L203.425781,189.015625 L198.425781,189.015625 L198.425781,181.015625 L203.425781,181.015625 Z M193.425781,181.015625 L193.425781,189.015625 L188.425781,189.015625 L188.425781,181.015625 L193.425781,181.015625 Z" id="形状结合"></path>
                  </g>
              </g>
          </svg>
       </div>
    </div>

  </div>
</template>

<script>


export default {
  name: 'custitle',

  props: {   
    txt: {
        type: String,
        default: "你的标题"
    },
    leftShow:{
        type: Boolean,
        default: true
    },    
    rightShow:{
        type: Boolean,
        default: true
    }    
  },
  data () {  
    return {
        
    }
  },
  methods: {
  
  },
  mounted () {
 
  }
}
</script>

<style lang="scss" type="text/scss">
  .titlebox{
          display: flex;
        align-items: center;
        justify-content: space-between;
         padding: 5px 12px;
         padding-top:10px ;
      .txt{
        font-size: 18px;
        color: #4FAEFF;
        position: absolute;             
        left: 28px;
      }
      .left{
        // height: 24px;
              display: flex;
            align-items: center;
      }
  }
  .device_phone{
    .titlebox{
      .txt{
        font-size: initial  !important;
      }     
    }
  }
  // .mipad{
  //   .titlebox{
  //     .txt{
  //       font-size: 19px  !important;
  //     }     
  //   }
  // }
</style>